import React, { useState } from "react";
import { useBlogs, useSearchBlogs } from "../../hooks/useBlog";
import toast from "react-hot-toast";

const Blog1 = () => {
  const [text, setText] = useState("");
  const { refetch: refetchAll } = useBlogs();
  const { refetch: refetchSearch } = useSearchBlogs(text);

  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      const result = await refetchSearch();
      if (result?.data?.data?.length === 0 || !result?.data?.data?.length) {
        refetchAll();
        toast.error("No blogs found");
      }
      setText("");
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <div className="2xl:container w-full flex flex-col items-center blobbg relative">
        <div className=" flex flex-col py-16 md:py-[96px]">
          <p className="font-avenir font-[900] text-24 md:text-32 text-headingtext lg:text-48 md:leading-[72px]">
            Our Blog
          </p>
        </div>
      </div>
      <div className="2xl:container mx-auto w-full">
        <form
          className=" mt-10 w-full flex justify-center sm:mt-12"
          onSubmit={(e) => handleSearch(e)}
        >
          <div className="flex max-w-[800px] w-[90%] sm:w-[80%]">
            <input
              type="text"
              name="search"
              onChange={(e) => setText(e.target.value)}
              value={text}
              placeholder="Search"
              className="outline-none w-full  p-3 border border-[#CED0D6]  rounded-[8px] rounded-r-none"
            />
            <button
              type="submit"
              disabled={!text.trim()}
              className={`p-3 rounded-r-[8px] text-white transition  bg-[#002DA3] hover:bg-[#0036cc]
             ${!text.trim() ? " cursor-not-allowed " : " cursor-pointer"}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-search"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                <path d="M21 21l-6 -6" />
              </svg>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Blog1;
